import request from '@/utils/request'
import store from '@/store'

//留言
export function addLeaveComment(data) {
  return request(
    {
      url: '/api/website/addLeaveComment',
      method: 'post',
      data
    },
    res => {
      if (res.code === 200 || res.code === 1) {
        return 'cancel'
      } else {
        return false
      }
    }
  )
}

// 企业简介
export function getIntro(data) {
  return request(
    {
      url: store.getters.urlStatus
        ? '/official/setting/introass'
        : '/official/setting/intro',
      method: 'get'
    },
    res => {
      if (res.code === 200 || res.code === 1) {
        return 'cancel'
      } else {
        return false
      }
    }
  )
}

// 组织架构
export function getManagement(data) {
  return request(
    {
      url: store.getters.urlStatus
        ? '/official/setting/managementass'
        : '/official/setting/management',
      method: 'get'
    },
    res => {
      if (res.code === 200 || res.code === 1) {
        return 'cancel'
      } else {
        return false
      }
    }
  )
}

// 发展历程
export function getDevelope() {
  return request(
    {
      url: store.getters.urlStatus
        ? '/official/setting/developeass'
        : '/official/setting/develope',
      method: 'get'
    },
    res => {
      if (res.code === 200 || res.code === 1) {
        return 'cancel'
      } else {
        return false
      }
    }
  )
}

//企业荣誉
export function getHonor() {
  return request(
    {
      url: store.getters.urlStatus
        ? '/official/setting/honorass'
        : '/official/setting/honor',
      method: 'get'
    },
    res => {
      if (res.code === 200 || res.code === 1) {
        return 'cancel'
      } else {
        return false
      }
    }
  )
}

// 品农文化
export function getCulture() {
  return request(
    {
      url: store.getters.urlStatus
        ? '/official/setting/cultureass'
        : '/official/setting/culture',
      method: 'get'
    },
    res => {
      if (res.code === 200 || res.code === 1) {
        return 'cancel'
      } else {
        return false
      }
    }
  )
}

//品农生活
export function getLife() {
  return request(
    {
      url: store.getters.urlStatus
        ? '/official/setting/lifeass'
        : '/official/setting/life',
      method: 'get'
    },
    res => {
      if (res.code === 200 || res.code === 1) {
        return 'cancel'
      } else {
        return false
      }
    }
  )
}
